module.exports = __webpack_public_path__ + "img/jian.1fa34523.png";